import { render, staticRenderFns } from "./TarjetaComercial.vue?vue&type=template&id=67c56217"
import script from "./TarjetaComercial.vue?vue&type=script&lang=js"
export * from "./TarjetaComercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports